import {Button} from 'primereact/button'

const AuditLogButton = ({label, onClick = () => {}}) => {
    const fontSize = 'text-xs sm:text-xs md:text-md lg:text-lg'
    return (
        <Button
            label={label}
            className={`p-button-text gap-1 audit-button ${fontSize} white-space-nowrap w-20rem`}
            icon="pi pi-download"
            onClick={onClick}
        />
    )
}

export default AuditLogButton
